export const getCard1 = (state) => state.table.card1;
export const getCard2 = (state) => state.table.card2;
export const getCard3 = (state) => state.table.card3;
export const getCard4 = (state) => state.table.card4;
export const getBb = (state) => state.table.bb;
export const getStake = (state) => state.table.stake;
export const getTs = (state) => state.table.ts;
export const getGgps = (state) => state.table.ggps;
export const getSuit = (state) => state.table.suit;
export const getSuitQuality = (state) => state.table.suitQuality;
export const getTableCombinations = (state) => state.table;
